import React from 'react';
import '../styles/ContactUs.css';

const ContactUs = () => {
  return (
    <div className="contact-wrapper">
      {/* Company Details Section */}
      <div className="company-details">
        <img className="logo1" src="./slogo.png" alt="logo" />
        <p>📍 No. 136B, KIADB Industrial 
              Area, Jigani Bommasandra 
              Link Road, Bangalore 
                560105</p>
           <p>📞 Phone: <a href="tel:9900415325" className="contact-link">+91-9900415325</a></p>
            <p>📧 Email: <a href="mailto:niranjanu@sujayindustries.in" className="contact-link">niranjanu@sujayindustries.in</a></p>
        <p>🕒 Hours: Mon - Sat, 9 AM - 6 PM</p>
        <p> 24/7 Customer Support</p>
      </div>

      {/* Map Section */}
      <div className="contact-map">
        <div className="map-container">
          {/* Embedded Google Map */}
          <iframe
            title="Company Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3890.768645264554!2d77.65417839130562!3d12.793523877634339!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae6c0e7580cf19%3A0x5db355b3add4cedc!2sSujay%20Industries!5e0!3m2!1sen!2sin!4v1731324917285!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
